import { TIMEKEEPING_STATUSES } from '../../timekeepingConstants';

export const TIMECARD_HISTORY_EVENT_TYPES = {
  clockIn: 'clockIn',
  clockOut: 'clockOut',
  dispute: 'dispute',
  resolve: 'resolve',
  edit: 'edit',
  sendForReview: 'sendForReview',
  approve: 'approve',
  finalize: 'finalize',
};

export const ACTION_TYPE_TEXT_KEYS = {
  [TIMECARD_HISTORY_EVENT_TYPES.clockIn]:
    'timekeeping.workerTimecard.timecardHistoryCard.actionType.clockIn',
  [TIMECARD_HISTORY_EVENT_TYPES.clockOut]:
    'timekeeping.workerTimecard.timecardHistoryCard.actionType.clockOut',
  [TIMECARD_HISTORY_EVENT_TYPES.dispute]:
    'timekeeping.workerTimecard.timecardHistoryCard.actionType.dispute',
  [TIMECARD_HISTORY_EVENT_TYPES.resolve]:
    'timekeeping.workerTimecard.timecardHistoryCard.actionType.resolve',
  [TIMECARD_HISTORY_EVENT_TYPES.edit]:
    'timekeeping.workerTimecard.timecardHistoryCard.actionType.edit',
  [TIMECARD_HISTORY_EVENT_TYPES.sendForReview]:
    'timekeeping.workerTimecard.timecardHistoryCard.actionType.sendForReview',
  [TIMECARD_HISTORY_EVENT_TYPES.approve]:
    'timekeeping.workerTimecard.timecardHistoryCard.actionType.approve',
  [TIMECARD_HISTORY_EVENT_TYPES.finalize]:
    'timekeeping.workerTimecard.timecardHistoryCard.actionType.finalize',
};

export const TIMECARD_HISTORY_STATUS_TEXT_KEYS = {
  [TIMEKEEPING_STATUSES.PENDING]: 'timekeeping.workerTimecard.status.pending',
  [TIMEKEEPING_STATUSES.APPROVED]: 'timekeeping.workerTimecard.status.approved',
  [TIMEKEEPING_STATUSES.RESOLVED]: 'timekeeping.workerTimecard.status.resolved',
  [TIMEKEEPING_STATUSES.DISPUTED]: 'timekeeping.workerTimecard.status.disputed',
  [TIMEKEEPING_STATUSES.FINALIZED]: 'timekeeping.workerTimecard.status.finalized',
};

export const EVENT_TIME_DATA_SECTION_TYPES = {
  TIMECARD: 'timecard',
  PROPOSED: 'proposed',
  BEFORE: 'before',
  AFTER: 'after',
};

export const EVENT_TIME_DATA_SECTIONS = [
  EVENT_TIME_DATA_SECTION_TYPES.TIMECARD,
  EVENT_TIME_DATA_SECTION_TYPES.PROPOSED,
  EVENT_TIME_DATA_SECTION_TYPES.BEFORE,
  EVENT_TIME_DATA_SECTION_TYPES.AFTER,
];

export const TIME_ACTION_LABEL_KEYS = {
  [EVENT_TIME_DATA_SECTION_TYPES.BEFORE]:
    'timekeeping.workerTimecard.timecardHistoryCard.detailTimecardLabel.before',
  [EVENT_TIME_DATA_SECTION_TYPES.AFTER]:
    'timekeeping.workerTimecard.timecardHistoryCard.detailTimecardLabel.after',
  [EVENT_TIME_DATA_SECTION_TYPES.PROPOSED]:
    'timekeeping.workerTimecard.timecardHistoryCard.detailTimecardLabel.proposed',
  [EVENT_TIME_DATA_SECTION_TYPES.TIMECARD]:
    'timekeeping.workerTimecard.timecardHistoryCard.detailTimecardLabel.timecard',
};

export const MODIFIER_TYPES = {
  USER: 'user',
  SYSTEM: 'system',
};
